import React from "react";

export default (id, data, update, setMatchData) => {
    const locale = "de";
    let baseUrl = location.origin;
    let endPoint = baseUrl + `/admin/api/dhbmatches/${id}?locale=${locale}`;

    const payload = {
        ...data,
        ...update,
        liveTicker: true,
    };
    const requestOptions = {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
    };

    return fetch(endPoint, requestOptions)
        .then((response) =>
            response.json().then((data) => {
                setMatchData(data);
                return data;
            })
        )
        .catch((e) => {
            console.log(e.message);
        });
};
